import { Header } from '@/components/Header';
import { TopBar } from '@/components/TopBar';
import { Footer } from '@/components/Footer';

export default function TermsOfService() {
  return (
    <div className="min-h-screen bg-white">
      <TopBar />
      <Header />
      
      <main className="pt-24 pb-20">
        <div className="container-0g">
          <div className="max-w-4xl mx-auto">
            <h1 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4">Terms of Service</h1>
            <p className="text-slate-500 mb-8">Last updated: March 14, 2026</p>
            
            <div className="prose prose-slate max-w-none">
              <p className="text-lg text-slate-600 mb-8">
                These Terms of Service ("Terms") govern your access to and use of the 0g Baltics website and services. By accessing or using our services, you agree to be bound by these Terms.
              </p>

              <section className="mb-10">
                <h2 className="text-2xl font-semibold text-slate-900 mb-4">1. Services</h2>
                <p className="text-slate-600">
                  0g Baltics provides IoT infrastructure solutions, consulting services, and related products for businesses, municipalities, and organizations. Our services include but are not limited to smart metering, asset tracking, indoor air quality monitoring, and connectivity infrastructure.
                </p>
              </section>

              <section className="mb-10">
                <h2 className="text-2xl font-semibold text-slate-900 mb-4">2. Eligibility</h2>
                <p className="text-slate-600">
                  Our services are intended for business use. By using our services, you represent that you are authorized to bind your organization to these Terms and that you are at least 18 years of age.
                </p>
              </section>

              <section className="mb-10">
                <h2 className="text-2xl font-semibold text-slate-900 mb-4">3. Use of Services</h2>
                <p className="text-slate-600 mb-4">You agree to:</p>
                <ul className="list-disc pl-6 text-slate-600 space-y-2">
                  <li>Use our services only for lawful purposes</li>
                  <li>Provide accurate and complete information when requested</li>
                  <li>Maintain the confidentiality of any account credentials</li>
                  <li>Not attempt to interfere with or disrupt our services</li>
                  <li>Not use our services to infringe on others' rights</li>
                </ul>
              </section>

              <section className="mb-10">
                <h2 className="text-2xl font-semibold text-slate-900 mb-4">4. Intellectual Property</h2>
                <p className="text-slate-600">
                  All content, trademarks, and intellectual property on our website and in our services are owned by 0g Baltics or our licensors. You may not copy, modify, or distribute our content without prior written consent.
                </p>
              </section>

              <section className="mb-10">
                <h2 className="text-2xl font-semibold text-slate-900 mb-4">5. Confidentiality</h2>
                <p className="text-slate-600">
                  Any confidential information shared between parties during the course of business discussions or service delivery shall be kept confidential and not disclosed to third parties without prior written consent, except as required by law.
                </p>
              </section>

              <section className="mb-10">
                <h2 className="text-2xl font-semibold text-slate-900 mb-4">6. Limitation of Liability</h2>
                <p className="text-slate-600">
                  To the maximum extent permitted by law, 0g Baltics shall not be liable for any indirect, incidental, special, consequential, or punitive damages arising from your use of our services. Our total liability shall not exceed the amounts paid by you for the specific services giving rise to the claim.
                </p>
              </section>

              <section className="mb-10">
                <h2 className="text-2xl font-semibold text-slate-900 mb-4">7. Warranty Disclaimer</h2>
                <p className="text-slate-600">
                  Our services are provided "as is" without warranties of any kind, either express or implied. We do not warrant that our services will be uninterrupted, error-free, or completely secure.
                </p>
              </section>

              <section className="mb-10">
                <h2 className="text-2xl font-semibold text-slate-900 mb-4">8. Indemnification</h2>
                <p className="text-slate-600">
                  You agree to indemnify and hold harmless 0g Baltics, its affiliates, and their respective officers, directors, employees, and agents from any claims, damages, or expenses arising from your use of our services or violation of these Terms.
                </p>
              </section>

              <section className="mb-10">
                <h2 className="text-2xl font-semibold text-slate-900 mb-4">9. Termination</h2>
                <p className="text-slate-600">
                  We may suspend or terminate your access to our services at any time for violation of these Terms or for any other reason at our sole discretion. Upon termination, your right to use our services will immediately cease.
                </p>
              </section>

              <section className="mb-10">
                <h2 className="text-2xl font-semibold text-slate-900 mb-4">10. Governing Law</h2>
                <p className="text-slate-600">
                  These Terms shall be governed by and construed in accordance with the laws of the Republic of Lithuania, without regard to its conflict of law provisions. Any disputes shall be subject to the exclusive jurisdiction of the courts of Vilnius, Lithuania.
                </p>
              </section>

              <section className="mb-10">
                <h2 className="text-2xl font-semibold text-slate-900 mb-4">11. Changes to Terms</h2>
                <p className="text-slate-600">
                  We reserve the right to modify these Terms at any time. Changes will be effective upon posting to our website. Your continued use of our services constitutes acceptance of the modified Terms.
                </p>
              </section>

              <section className="mb-10">
                <h2 className="text-2xl font-semibold text-slate-900 mb-4">12. Contact</h2>
                <p className="text-slate-600">
                  For questions about these Terms, please contact us at: <a href="mailto:info@0gbaltics.com" className="text-teal-600 hover:underline">info@0gbaltics.com</a>
                </p>
              </section>
            </div>
          </div>
        </div>
      </main>
      
      <Footer />
    </div>
  );
}
